export type AddOrRemoveButtonsProps = {
  onAddOrRemove: (action: 'add' | 'remove') => void;
  isDisabled?: boolean;
};

export function AddOrRemoveButtons({ onAddOrRemove, isDisabled }: AddOrRemoveButtonsProps) {
  return (
    <>
      <button
        type="button"
        className="btn btn-flat-secondary btn-lg btn-icon"
        onClick={() => onAddOrRemove('remove')}
        disabled={isDisabled}
      >
        <i className="icon">remove</i>
      </button>
      <button
        type="button"
        className="btn btn-flat-secondary btn-lg btn-icon"
        onClick={() => onAddOrRemove('add')}
        disabled={isDisabled}
      >
        <i className="icon">add</i>
      </button>
    </>
  );
}
